import React, { Component } from 'react'
import { BrowserRouter as Router, Route, useParams, Switch } from "react-router-dom";
// import Header from './components/common/Header'
// import SideNav from './components/common/SideNav'
import { Provider } from 'react-redux'
import store from './store'
import './App.css'
import { _BASIC_TRANSACTIONS, _MCP, _3DS2, _VAULTFINANCIAL, _RECURRING_BILLING, _VAULT, _MCO, _JAVA, _DOTNET, _PHP } from './actions/types'
import HomePage from './pages/HomePage'
import NotFoundPage from './pages/NotFoundPage'
import TransactionsPage from './pages/TransactionsPage'
import RecurringPage from './pages/RecurringPage'
import VaultPage from './pages/VaultPage'
import VaultFinancialPage from './pages/VaultFinancialPage'
import MCPPage from './pages/MCPPage'
import ThreeDSTwoPage from './pages/ThreeDSTwoPage'
import MCOPage from './pages/MCOPage'

import Header from './components/common/Header'
// import Footer from './components/common/Footer'

import { selectStep, selectMode, selectProgLang } from './actions/commonActions'

import TransactionsSteps from './constants/transactions/steps'
import RecurringSteps from './constants/recurring/steps'
import VaultSteps from './constants/vault/steps'
import VaultFinancialSteps from './constants/vaultFinancial/steps'
import MCPSteps from './constants/mcp/steps'
import ThreeDSTwoSteps from './constants/3DS2/steps'
import MCOSteps from './constants/checkout/steps'


class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router basename= "/livedemo">
          <Switch>

            <Route exact path="/">
              <Header />
              <HomePage />
            </Route>

            <Route path="/:featureId/:stepId/:mode/:prog/:x">
              <div>
                <Header />
                <NotFoundPage />
              </div>
            </Route>

            <Route path="/:featureId/:stepId/:mode/:prog">
              <div>
                <Header />
                <HandlePath4 />
              </div>
            </Route>

            <Route path="/:featureId/:stepId/:mode">
              <div>
                <Header />
                <HandlePath3 />
              </div>
            </Route>

            <Route path="/:featureId/:stepId">
              <div>
                <Header />
                <HandlePath2 />
              </div>
            </Route>

            <Route path="/:featureId">
              <div>
                <Header />
                <HandlePath />
              </div>
            </Route>

          </Switch>
        </Router>
      </Provider>
    );
  }
}

function HandlePath() {
  let { featureId, stepId } = useParams();
  
  switch(featureId) {
    case _BASIC_TRANSACTIONS: {
      if(!stepId) {
        const firstStep = TransactionsSteps[0].name;
        selectStep({ featureId, stepId: 1 })(store.dispatch);
        window.history.pushState({featureId, stepName: firstStep}, '', `/livedemo/${featureId}/${firstStep}/guide/dotnet`); //default stepId and mode
      }
      return <TransactionsPage />
    }

    case _RECURRING_BILLING: {
      if(!stepId) {
        const firstStep = RecurringSteps[0].name;
        selectStep({ featureId, stepId: 1 })(store.dispatch);
        window.history.pushState({featureId, stepName: firstStep}, '', `/livedemo/${featureId}/${firstStep}/guide/dotnet`); //default stepId and mode
      }
      return <RecurringPage />
    }
       
    case _VAULT: {
      if(!stepId) {
        const firstStep = VaultSteps[0].name;
        selectStep({ featureId, stepId: 1 })(store.dispatch);
        window.history.pushState({featureId, stepName: firstStep}, '', `/livedemo/${featureId}/${firstStep}/guide/dotnet`); //default stepId and mode
      }
      return <VaultPage />
    }

    case _VAULTFINANCIAL: {
      if(!stepId) {
        const firstStep = VaultFinancialSteps[0].name;
        selectStep({ featureId, stepId: 1 })(store.dispatch);
        window.history.pushState({featureId, stepName: firstStep}, '', `/livedemo/${featureId}/${firstStep}/guide/dotnet`); //default stepId and mode
      }
      return <VaultFinancialPage />
    }
      
    case _MCP: {
      if(!stepId) {
        const firstStep = MCPSteps[0].name;
        selectStep({ featureId, stepId: 1 })(store.dispatch);
        window.history.pushState({featureId, stepName: firstStep}, '', `/livedemo/${featureId}/${firstStep}/guide/dotnet`); //default stepId and mode
      }
      return <MCPPage />
    }

    case _3DS2: {
      if(!stepId) {
        const firstStep = ThreeDSTwoSteps[0].name;
        selectStep({ featureId, stepId: 1 })(store.dispatch);
        window.history.pushState({featureId, stepName: firstStep}, '', `/livedemo/${featureId}/${firstStep}/guide/dotnet`); //default stepId and mode
      }
      return <ThreeDSTwoPage />
    }
      
    case _MCO: {
      if(!stepId) {
        const firstStep = MCOSteps[0].name;
        selectStep({ featureId, stepId: 1 })(store.dispatch);
        window.history.pushState({featureId, stepName: firstStep}, '', `/livedemo/${featureId}/${firstStep}/guide/dotnet`); //default stepId and mode
      }
      return <MCOPage />
    }
       
    default:
      return <NotFoundPage />
  }
}

function HandlePath2() {
  let { featureId, stepId, mode } = useParams();
  const actualStepId = getActualStepId(stepId, featureId);

  if(actualStepId === -1) {
    return <NotFoundPage />
  }

  if(!mode) {
    window.history.pushState({featureId, stepName: stepId}, '', `/livedemo/${featureId}/${stepId}/guide/dotnet`); // integration_guide is the default mode
  }

  selectStep({ featureId, stepId: actualStepId })(store.dispatch);

  return <HandlePath />
}

function HandlePath3() {
  let { featureId, stepId, mode, prog } = useParams();

  if(!prog) {
    window.history.pushState({featureId, stepName: stepId}, '', `/livedemo/${featureId}/${stepId}/${mode}/dotnet`); // dotnet is the default prog lang
  }

  if(mode === 'tool')
    selectMode('interactive_tool')(store.dispatch);
  else if(mode === 'guide')
    selectMode('integration_guide')(store.dispatch);
  else
    return <NotFoundPage />
  
  return <HandlePath2 />
}

function HandlePath4() {
  let { featureId, stepId, mode, prog } = useParams();

  window.history.pushState({featureId, stepName: stepId}, '', `/livedemo/${featureId}/${stepId}/${mode}/${prog}`); // dotnet is the default prog lang

  if(prog === 'java') selectProgLang(_JAVA)(store.dispatch);
  else if(prog === 'dotnet') selectProgLang(_DOTNET)(store.dispatch);
  else if(prog === 'php') selectProgLang(_PHP)(store.dispatch);
  else return <NotFoundPage />

  return <HandlePath3 />
}

function getActualStepId(stepId, featureId) {
  switch (featureId) {
    case _BASIC_TRANSACTIONS: {
      const _step = TransactionsSteps.find((step) => step.name === stepId)
      return _step !== undefined ? _step.id : -1
    }

    case _MCP: {
      const _step = MCPSteps.find((step) => step.name === stepId);
      return _step !== undefined ? _step.id : -1
    }

    case _VAULTFINANCIAL: {
      const _step = VaultFinancialSteps.find((step) => step.name === stepId);
      return _step !== undefined ? _step.id : -1
    }

    case _VAULT: {
      const _step = VaultSteps.find((step) => step.name === stepId);
      return _step !== undefined ? _step.id : -1
    }

    case _3DS2: {
      const _step = ThreeDSTwoSteps.find((step) => step.name === stepId);
      return _step !== undefined ? _step.id : -1
    }

    case _RECURRING_BILLING: {
      const _step = RecurringSteps.find((step) => step.name === stepId);
      return _step !== undefined ? _step.id : -1
    }

    case _MCO: {
      const _step = MCOSteps.find((step) => step.name === stepId);
      return _step !== undefined ? _step.id : -1
    }
  
    default:
      return -1
  }
  
}

export default App
